"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const CardBody_1 = __importDefault(require("./CardBody"));
const CardFooter_1 = __importDefault(require("./CardFooter"));
const CardGroup_1 = __importDefault(require("./CardGroup"));
const CardHeader_1 = __importDefault(require("./CardHeader"));
const CardMedia_1 = __importDefault(require("./CardMedia"));
const CardComponent = ({ children, className, exdent, flag, headerFirst, ...props }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-card', exdent && 'usa-card--exdent', flag && 'usa-card--flag', flag === 'right' && 'usa-card--media-right', headerFirst && 'usa-card--header-first', className), ...props, children: (0, jsx_runtime_1.jsx)("div", { className: "usa-card__container", children: exdent
                ? react_1.Children.map(children, (child) => {
                    if ((0, react_1.isValidElement)(child)) {
                        return (0, react_1.cloneElement)(child, {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            exdent: true
                        });
                    }
                    return child;
                })
                : children }) }));
};
const Card = Object.assign(CardComponent, {
    Body: CardBody_1.default,
    Footer: CardFooter_1.default,
    Group: CardGroup_1.default,
    Header: CardHeader_1.default,
    Media: CardMedia_1.default
});
exports.default = Card;
